var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.isAlive && _vm.isRouterAlive)?_c('router-view'):_vm._e()],1),(!_vm.isAlive && _vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.loading)?_c('div',{staticClass:"loading_mask"},[_c('cube-loading',{attrs:{"id":"loading_"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }